var React = require('react');

function Archive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 4H4C2.89543 4 2 4.89543 2 6V7C2 8.10457 2.89543 9 4 9H20C21.1046 9 22 8.10457 22 7V6C22 4.89543 21.1046 4 20 4Z","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V9","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10 13H14","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Archive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Archive;

Archive.default = Archive;
